// extracted by mini-css-extract-plugin
export default {"homologacaoBotoes":"ArquivarSolicitacao_homologacaoBotoes__jqN+7","motivoArquivamento":"ArquivarSolicitacao_motivoArquivamento__BDqCa"};